import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";

import {GoogleMap, Marker} from 'react-google-maps';
import {BasicGoogleMap} from "../../../../../components/map/Map";
import Divider from '@material-ui/core/Divider';

import user from "./../../../../../assets/user.png"
import icon from "./../../../../../assets/my_location_marker.png"
import {fetchNotes} from "../../../../../actions/visits_actions";
import {dateTimeFormat} from "../../../../../utils/formatters";
import EmptyState from "../../../../../components/emptyState";
import mapStyles from '../../../../../utils/mapStyles';
import "./styles.scss";
import VerticalAlign from "../../../../../components/verticalAlign/VerticalAlign";


class StationInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            user: null
        };
    }

    componentDidMount() {
        this._getLocation();
    }

    _getLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                this.setState({
                    user: {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    }
                });
            });
        }
    };

    _mapRender = (props) => {
        let location = {
            lat: parseFloat(props.station.latitude),
            lng: parseFloat(props.station.longitude)
        };

        return (
            <GoogleMap
                defaultZoom={10}
                center={location}
                defaultCenter={location}
                defaultOptions={mapStyles}
            >
                <Marker position={location}/>

                {props.user &&
                props.user.lat &&
                props.user.lng && <Marker position={props.user} options={{ icon }} />}
            </GoogleMap>
        );
    };

    render() {
        let station = this.props.station;
        return (
            <div className={'station-detail'}>
                {station &&
                <div>
                    <div className={"map"}>
                        <BasicGoogleMap
                            station={station}
                            renderMethod={this._mapRender}
                            user={this.state.user}
                        />

                    </div>
                    <div className={"station"}>BOCA {station.global_code}</div>
                    <div className={"address"}>{station.address}</div>
                    <div className={"address"}>{station.city}</div>
                    <Divider style={{marginTop: 10}}/>
                    <div className={"lastvisit"}>ULTIMA VISITA</div>
                    {this.props.visits && this.props.visits.lastVisitInfo &&
                    <div className={"user-time"}>
                        <img src={user} className={"icon-user"} alt={'User'}/>
                        <div className={"username"}>{this.props.visits.lastVisitInfo.tm_user_display}</div>
                        <div className={"date"}>{dateTimeFormat(this.props.visits.lastVisitInfo.created_at)}</div>
                    </div>}
                    {this.props.visits && !this.props.visits.lastVisitInfo &&
                        <div className={"lastvisit-empty"}>No hay información de última visita</div>
                    }
                    <Divider/>
                    {/*<div className={"done"}>*/}
                    {/*<img src={time} className={"icon-time"} alt={"Time"}/>*/}
                    {/*<div className={"done-text"}>REALIZADAS</div>*/}
                    {/*</div>*/}
                </div>
                }

                {!station &&
                <VerticalAlign>
                    <EmptyState text={"No hay una boca seleccionada"}/>
                </VerticalAlign>
                }
            </div>


        );
    }
}


const mapStateToProps = (state) => {
    return {
        user: state.user,
        visits: state.visits,
        stations: state.stations
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({fetchNotes}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(StationInfo);


// WEBPACK FOOTER //
// ./src/containers/site-visits/stationDetail/components/stationInfo/StationInfo.js